/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {PERMISSIONS} from '../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../_helpers/UserPermissionSingleton';

export default class BookCoverImage extends React.Component {
    constructor(props) {
        super(props);

        this.changeFrontCoverImageAndCloseModal = this.changeFrontCoverImageAndCloseModal.bind(this);
        this.modalTriggerComponent = this.modalTriggerComponent.bind(this);
        this.loadFrontCoverImages = this.loadFrontCoverImages.bind(this);
    }

    static get propTypes() {
        return {
            collectionId: PropTypes.string,
            currentBookCoverUrl: PropTypes.string,
            frontCoverImages: PropTypes.array,
            changeFrontCoverImage: PropTypes.func,
            openModal:PropTypes.func,
            hideModalVisibility:PropTypes.bool,
        };
    }

    changeFrontCoverImageAndCloseModal(collectionId, frontCoverImageId) {
        this.props.changeFrontCoverImage(collectionId, frontCoverImageId);
    }

    loadFrontCoverImages() {
        if (this.props.frontCoverImages.length === 0) {
            this.props.getFrontCoverImages(this.props.collectionId);
        }
    }

    modalTriggerComponent() {
        return (<img className="book-cover-image-preview" src={this.props.currentBookCoverUrl}
            alt="Book Cover" />);
    }

    render() {
        const {currentBookCoverUrl } = this.props;
        return (
            !UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_cover_design)?  
                (currentBookCoverUrl === '' || !currentBookCoverUrl)?
                    <div className="cover-image-empty">No image</div>
                    :
                    <img className="cover-image-thumbnail view_thumbnail" src={this.props.currentBookCoverUrl} onClick={this.props.hideModalVisibility ? () => false : () => this.props.openModal()}/>
                :
                (currentBookCoverUrl === '' || !currentBookCoverUrl) ?
                    <div className="cover-image-empty">No image</div>
                    :
                    <img className= {"cover-image-thumbnail" + (this.props.hideModalVisibility ? "cursor-default" : '')} src={currentBookCoverUrl} onClick={this.props.hideModalVisibility ? () => false : () => this.props.openModal()}/>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/BookCoverImage.js